/**
 * メッセージグループ
 */
export const MessageGroups = {
  NONE: -1, // なし
  P_JUDGE_DISCUSSION: 1, // 要否判断
  P_PRIOR_DISCUSSION: 2, // 事前協議
  P_DISCUSSION_DOCUMENT: 3, // 協議書
  P_WITNESS: 4, // 現地立会
  P_ANSWER: 5, // 回答
  P_ADVERSARIA: 6, // 覚書等
  P_APPLICANT_CALL: 7, // 申請者連絡
  P_OTHER: 8, // 近接協議（その他）
  B_PRELIMINARY_SURVEY: 11, // 事前調査
  B_WITNESS: 12, // 境界立会
  B_APPLICANT_CALL: 13, // 申請者連絡
  B_OTHER: 14, // 境界立会（その他）
} as const
